import React from 'react';
import { InertiaLink } from '@inertiajs/inertia-react';

export default ({ link, product }) =>(
     <InertiaLink className="w-full flex flex-col mb-3 text-gray-500 hover:text-emerald-500" href={route(link, product.slug)}>
          <div className="w-full bg-white border-2 border-gray-200 p-2 rounded-md shadow-lg">
              <div className="flex justify-start">
                   <div className="flex-none w-1/3 rounded mr-2">
                         <img className="w-full" alt={product.name} src={product.image?product.image:`https://ui-avatars.com/api/?name=${product.name}&amp;color=7F9CF5&amp;background=DEE8D8`} />
                   </div>
                   <div className="w-2/3">
                        <h4 className="text-md font-semibold mb-2">{product.name}</h4>
                   </div>
              </div>
         </div>
     </InertiaLink>
);
